<template>
	<Page v-show="show" class="page" @on-page-size-change="totalPageChange" :page-size="pageSize"
		:page-size-opts="opts" :total="pageTotal" size="small" show-elevator show-sizer @on-change="pageChange"
		:current="chectedPage" />
</template>

<script>
	export default {
		props: ['param', 'url'],
		data() {
			return {
				//分页属性
				pageTotal: 0,
				pageSize: 20,
				opts: [20, 100, 1000, 3000],
				chectedPage: 1,
				show: true,
			};
		},
		methods: {
			pageChange: function(a) {
				console.log(a)
				this.chectedPage = a;
				// this.pageTotal = this.getList();
				this.getList();
			},
			totalPageChange: function(a) {
				this.pageSize = a;
				// this.pageTotal = this.getList();
				this.getList();
			},
			getList: function(flag) {
				const _this = this;
				let params1 = {
					Page: _this.chectedPage,
					PageSize: _this.pageSize,

				};

				_this.$emit("tableLoading", true);
				this.pageTotal = 0;
				const params = Object.assign(_this.param, params1);
				return _this.$axios.post(_this.url, params).then(res => {
					if (res.data.Code == 0 || res.data.Code == 200) {
						_this.pageTotal = res.data.Total
						// if(flag!=undefined){
						// 		_this.$emit(flag, res.data)
						// }else{
						// 	_this.$emit("listData", res.data)
						// }
						_this.$emit("listData", res.data)
					}
				}).finally(() => {
					_this.$emit("tableLoading", false);
				});
			},
		}
	}
</script>

<style>
	.ivu-table-footer {
		border-top: 1px solid #e8eaec;
		padding: 0;
		margin: 0;
	}
</style>